import React, { useEffect, useState } from 'react';
import { addNotification, deleteNotification, getAllNotifications, updateNotification } from '../../services/api';

const AdminNotifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);

    // Form states
    const [title, setTitle] = useState('');
    const [thumbnail, setThumbnail] = useState(null);
    const [content, setContent] = useState('');
    const [file, setFile] = useState(null);
    const [type, setType] = useState('Chính');
    const [isEditing, setIsEditing] = useState(false);
    const [editingNotification, setEditingNotification] = useState(null);

    const itemsPerPage = 5;

    useEffect(() => {
        getAllNotifications()
            .then((res) => setNotifications(res.data))
            .catch((err) => console.error('Lỗi khi tải thông báo:', err));
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('title', title);
        formData.append('message', content);
        formData.append('type', type);
        if (thumbnail) formData.append('thumbnail', thumbnail);
        if (file) formData.append('file', file);

        if (isEditing && editingNotification) {
            updateNotification(editingNotification.id, formData)
                .then((res) => {
                    alert('Đã cập nhật thông báo!');
                    setNotifications((prev) =>
                        prev.map((n) => (n.id === res.data.id ? res.data : n))
                    );
                    resetForm();
                    setShowModal(false);
                })
                .catch(() => alert('Có lỗi khi cập nhật!'));
        } else {
            addNotification(formData)
                .then((res) => {
                    alert('Đã thêm thông báo!');
                    setNotifications([res.data, ...notifications]);
                    resetForm();
                    setShowModal(false);
                })
                .catch(() => alert('Có lỗi xảy ra!'));
        }
    };

    const handleDelete = (id) => {
        if (window.confirm('Bạn chắc chắn xoá?')) {
            deleteNotification(id)
                .then(() => {
                    setNotifications(notifications.filter((n) => n.id !== id));
                })
                .catch(() => alert('Không thể xoá.'));
        }
    };

    const filtered = notifications.filter((n) =>
        (n.title ?? '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    const paginated = filtered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(filtered.length / itemsPerPage);

    const resetForm = () => {
        setTitle('');
        setThumbnail(null);
        setContent('');
        setFile(null);
        setIsEditing(false);
        setEditingNotification(null);
    };

    return (
        <div className="p-6 bg-white rounded shadow space-y-6">
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Quản Lý Thông Báo</h1>
                <p className="text-gray-600">Quản lý thông tin và nội dung các thông báo</p>
            </div>

            <div className="bg-white p-4 rounded-lg shadow-sm flex justify-between items-center mb-6">
                <div className="flex gap-2">
                    <button
                        onClick={() => {
                            resetForm();
                            setType('Chính');
                            setShowModal(true);
                        }}
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                    >
                        + Thêm Thông Báo Chính
                    </button>

                    <button
                        onClick={() => {
                            resetForm();
                            setType('Phụ');
                            setShowModal(true);
                        }}
                        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    >
                        + Thêm Thông Báo Phụ
                    </button>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full border rounded">
                    <thead>
                        <tr className="bg-sky-500 text-white">
                            <th className="p-3 text-left">Loại</th>
                            <th className="p-3 text-left">Tiêu đề</th>
                            <th className="p-3 text-left">Nội dung</th>
                            <th className="p-3 text-left">Thumbnail</th>
                            <th className="p-3 text-left">Tệp đính kèm</th>
                            <th className="p-3 text-left">Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginated.map((n) => (
                            <tr key={n.id} className="border-b">
                                <td className="p-3">{n.type === 'Chính' ? 'Chính' : 'Phụ'}</td>
                                <td className="p-3">{n.title}</td>
                                <td className="p-3">{n.message}</td>
                                <td className="p-3">
                                    {n.thumbnail_url ? (
                                        <img
                                            src={n.thumbnail_url}
                                            alt="thumbnail"
                                            className="h-12 w-12 object-cover rounded"
                                        />
                                    ) : (
                                        'Không có'
                                    )}
                                </td>
                                <td className="p-3">
                                    {n.file_url ? (
                                        <a href={n.file_url} target="_blank" rel="noreferrer" className="text-blue-600 underline">
                                            {n.file_url.split('/').pop()}
                                        </a>
                                    ) : (
                                        'Không có'
                                    )}
                                </td>
                                <td className="p-3 space-x-2">
                                    <button
                                        className="bg-yellow-400 text-white px-3 py-1 rounded"
                                        onClick={() => {
                                            setIsEditing(true);
                                            setEditingNotification(n);
                                            setTitle(n.title);
                                            setContent(n.message);
                                            setType(n.type);
                                            setShowModal(true);
                                        }}
                                    >
                                        Sửa
                                    </button>
                                    <button
                                        onClick={() => handleDelete(n.id)}
                                        className="bg-red-500 text-white px-3 py-1 rounded"
                                    >
                                        Xoá
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="mt-4 flex justify-center space-x-2">
                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            onClick={() => setCurrentPage(i + 1)}
                            className={`px-4 py-2 rounded ${currentPage === i + 1 ? 'bg-sky-500 text-white' : 'bg-gray-200'}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
            </div>

            {/* Modal Thêm/Sửa Thông Báo */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
                        <h2 className="text-xl font-bold mb-4 text-center">
                            {isEditing ? 'Sửa Thông Báo' : 'Thêm Thông Báo Mới'}
                        </h2>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <input
                                type="text"
                                placeholder="Tiêu đề"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                className="w-full border rounded px-4 py-2"
                                required
                            />

                            {type === 'Chính' && (
                                <>
                                    {isEditing && editingNotification?.thumbnail_url && (
                                        <div className="mb-2">
                                            <p className="text-sm text-gray-600">Thumbnail hiện tại:</p>
                                            <img
                                                src={editingNotification.thumbnail_url}
                                                alt="thumbnail hiện tại"
                                                className="h-16 w-16 object-cover rounded"
                                            />
                                        </div>
                                    )}
                                    <hr />
                                    Thumbnail
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setThumbnail(e.target.files[0])}
                                        className="w-full"
                                    />
                                </>
                            )}

                            <textarea
                                placeholder="Nội dung"
                                value={content}
                                onChange={(e) => setContent(e.target.value)}
                                rows={4}
                                className="w-full border rounded px-4 py-2"
                                required
                            />
                            <hr />
                            File

                            <input
                                type="file"
                                onChange={(e) => setFile(e.target.files[0])}
                                className="w-full"
                            />

                            <div className="flex justify-end space-x-3">
                                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 bg-gray-200 rounded">
                                    Hủy
                                </button>
                                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                                    {isEditing ? 'Lưu thay đổi' : 'Thêm mới'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminNotifications;
